import { css, jsx } from '@emotion/core';
import { Button, Icon, Modal } from 'antd';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import btnStyle from '@/src/shared/components/Button/style';
import Heading from '@/src/shared/components/Heading';
import { space } from '@/styles';

import Descriptions from './PublicationDescriptions';

const index = props => {
  const { closeModal, visible } = props;
  const { m } = space;

  const style = {
    titleContainer: css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    `,
  };

  return (
    <Modal
      footer={null}
      title={
        <span css={style.titleContainer}>
          <Heading type={2} weight="bolder" theme="gray" css={m.b0}>
            Publication Descriptions
          </Heading>
          <Link href="/account/subscription-preferences/general-publications/">
            <a target="_blank">
              <Button.Group theme="gray" css={[btnStyle.group, m.r24]}>
                <Button>
                  <Icon type="printer" theme="filled" /> Print Version
                </Button>
              </Button.Group>
            </a>
          </Link>
        </span>
      }
      onCancel={closeModal}
      visible={visible}
      width="71%"
    >
      <Descriptions />
    </Modal>
  );
};

index.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default index;
